export const FETCH_COACH_REQUEST = 'FETCH_COACH_REQUEST';
export const FETCH_COACH_SUCCESS = 'FETCH_COACH_SUCCESS';
export const FETCH_COACH_FAILURE = 'FETCH_COACH_FAILURE';
